var render, staticRenderFns
import script from "./SnackbarsMixin.vue?vue&type=script&lang=js"
export * from "./SnackbarsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c30144",
  null
  
)

export default component.exports